import { olympusService as e } from "../services/olympus/olympus.service.js";
import { useCurrentSpaceStore as t } from "../stores/current-space-store/useCurrentSpaceStore.js";
import "../stores/index.js";
import { useCallback as n, useState as r } from "react";
//#region src/lib/hooks/useUpdateSpaceMetadata.ts
var i = () => {
	let i = t((e) => e.space), a = t((e) => e.updateSpaceMetadata), [o, s] = r(!1);
	return {
		updateSpaceMetadata: n(async (t) => {
			if (!i) throw Error("useUpdateSpaceMetadata: no current space");
			let n = {
				...i.metadata,
				...t
			};
			a({
				...i,
				metadata: n
			}), s(!0);
			try {
				await e.client.spaces.updateSpaceMetadata(i.id, n);
			} finally {
				s(!1);
			}
		}, [i, a]),
		updatingMetadata: o
	};
};
//#endregion
export { i as useUpdateSpaceMetadata };
